import styled from '@emotion/styled'
import { Fonts } from '~/assets/style/fonts'

export const Title_P1 = styled.div`
  ${Fonts.P1}
  font-weight: 500;
`

export const Title_H2 = styled.h2`
  font-weight: 500;
`
